import axios from 'config/axiosConfig'
import setFilters from 'config/filters'
import { app_auth } from 'keys/apis'

export const getUsersFetch = ({ model, page, pageSize, sorting, search }) => {
    const params = setFilters({ model, page, pageSize, sorting, search })
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/`, {
        params: params
    })
}

export const updateUserBalanceFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/update_balance/`, {
        ...values
    })
}